import React, { createContext, useEffect, useMemo } from 'react';

import { setDomain, setLocale } from '../localization/strings';

interface ComponentProps {
  children: React.ReactNode;
}

interface ContextValue {
  locale: string;
  domain: string;
}

const SiteContext = createContext<ContextValue>({
  locale: '',
  domain: 'allergomedica',
});

function SiteContextProvider({ children }: ComponentProps) {
  const host = window.location.hostname;

  let locale = 'lt';
  let domain = 'allergomedica';

  if (host.includes('self.co')) {
    locale = 'en';
    domain = 'selfco';
    setLocale('en');
    setDomain('selfco');
  } else if (host.includes('allergomedica')) {
    setLocale('lt');
    setDomain('allergomedica');

    if (host.includes('allergomedica.pl') || host.includes('.pl.allergomedica')) {
      locale = 'pl';
      setLocale('pl');
    }

    if (host.includes('allergomedica.lv') || host.includes('.lv.allergomedica')) {
      locale = 'lv';
      setLocale('lv');
    }
  }

  useEffect(() => {
    if (domain === 'selfco') {
      document.body.classList.add('selfco');
      document.title = 'Partners Self.co';

      const iconMap: Record<string, string> = {
        'apple-touch-icon': '/selfco-apple-touch-icon.png',
        'icon-32': '/selfco-favicon-32x32.png',
        'icon-16': '/selfco-favicon-16x16.png',
      };

      document.querySelectorAll('link[rel="apple-touch-icon"]').forEach((el) => {
        el.setAttribute('href', iconMap['apple-touch-icon']);
      });
      document.querySelectorAll('link[rel="icon"][sizes="32x32"]').forEach((el) => {
        el.setAttribute('href', iconMap['icon-32']);
      });
      document.querySelectorAll('link[rel="icon"][sizes="16x16"]').forEach((el) => {
        el.setAttribute('href', iconMap['icon-16']);
      });
    } else {
      document.body.classList.remove('selfco');
    }
  }, [domain]);

  const contextValue = useMemo(() => ({ locale, domain }), [locale, domain]);

  return <SiteContext.Provider value={contextValue}>{children}</SiteContext.Provider>;
}

export { SiteContext, SiteContextProvider };
